import React, { useEffect, useState } from "react";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import "../../assets/css/Brochure.scss";
import { MdOutlineFileDownload } from "react-icons/md";

// Images

import { fetchBrochure } from "../../utils";
import { Helmet } from "react-helmet";


const Brochure = () => {
  const [brochures, setBrochures] = useState([]);
  useEffect(() => {
    const fetchBrochureData = async () => {
      const response = await fetchBrochure();
      setBrochures(response);
    };
    fetchBrochureData();
  }, []);
  const handleFileDownload = (filePath) => {
    if (!filePath) return;
    try {
      window.open(filePath);
    } catch (error) {
      console.error("Error loading file:", error);
    }
  };

  return (
    <>
      <Helmet>
        <title>Brochure | D'decor Rugs</title>
        <meta property="og:title" content="Brochure | D'decor Rugs" />
      </Helmet>
      <Header />
      <div className="brochure-page-container">
        <div className="brochure-page-main-content">
          <div className="all-brochure-cards-box">
            {brochures.map((item, index) => (
              <div
                className="brochure-main-card-details"
                key={index}
                onClick={() => handleFileDownload(item.pdf.url)}
              >
                <div className="brochure-card-image">
                  <div className="brochure-image">
                    <img src={item.image.url} alt="Brochure" />
                  </div>
                  <div className="download-overlay">
                    <div className="brochure-download">
                      <MdOutlineFileDownload className="download-icon" />
                    </div>
                  </div>
                </div>
                <p>{item.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Brochure;
